<template>
    <div class="modal" v-bind:class="modalClass">
        <div id="modal-overlay" @click="back()"></div>
        <article id="modal-edit" v-if="resource">
            <header>
                <figure><i class="icon icon-icon_company"></i></figure>
                <div>
                    <span class="breadcrumb">
                        Company <i class="icon icon-icon_arrow-right"></i> Edit
                    </span>
                    <h1>{{ resource.name ? resource.name : 'Nouveau' }}</h1>
                </div>
                <div class="spacer"></div>
                <div>
                    <button @click="back()" class="bt-back"><span><i class="icon icon-icon_arrow-left"></i></span></button>
                    <button @click="submit()" class="bt-primary bt-save"><span><i class="icon icon-icon_tick"></i></span></button>
                </div>
            </header>
            <tabs :options="{ useUrlFragment: false }">
                <tab name="Information">

                    <form-scopes label='Scopes' v-model="resource"></form-scopes>
                    <form-text label="Nom" v-model="resource.name"></form-text>
                    <form-file v-model="resource.picture_id"></form-file>

                    <component-attributes v-model="resource" :locale="locale"></component-attributes>

                </tab>
            </tabs>
        </article>
    </div>
</template>
<script>

    import CompanyService from './CompanyService.js';
    import Edit from '../../layouts/Edit.vue';
    import ComponentAttributes from "../../components/Attributes.vue";

    export default {
        extends: Edit,
        components:{
            'component-attributes': ComponentAttributes
        },
        data () {
            return {
            }
        },
        mounted: function(){
        },
        methods:{
            resourceLoaded: function(){
                this.localesLoaded = true;
            },
            getResource: function(){
                return {name: 'company', api: CompanyService}
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/company/Edit.vue